import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
  {
    id: 1,
    title: "Home",
    link: "/home",
  },
  {
    id: 2,
    title: "Empresa",
    link: "/about",
    submenu: [
      {
        id: 21,
        title: "Sobre Nós",
        link: "/about",
      },
      {
        id: 22,
        title: "Soluções",
        link: "/service",
      },
      {
        id: 23,
        title: "Projetos Entregues",
        link: "/projects",
      },
      {
        id: 24,
        title: "Termos & Condições",
        link: "/terms-conditions",
      },
      {
        id: 25,
        title: "Política de Privacidade",
        link: "/privacy-policy",
      },
    ],
  },
  {
    id: 3,
    title: "Soluções",
    link: "/service",
    submenu: [
      {
        id: 31,
        title: "Cloud VPS",
        link: "/cloud-vps",
      },
      {
        id: 32,
        title: "Cloud Server",
        link: "/cloud-server",
      },
      {
        id: 33,
        title: "Data Center Virtual",
        link: "/data-center-virtual",
      },
      {
        id: 34,
        title: "VDI Windows 11",
        link: "/vdi-windows11",
      },
      {
        id: 35,
        title: "Disaster Recovery",
        link: "/disaster-recorvery",
      },
      {
        id: 36,
        title: "Microsoft Exchange",
        link: "/microsoft-exchange",
      },
      {
        id: 37,
        title: "Firewall Comodato",
        link: "/firewall-comodato",
      },
      {
        id: 38,
        title: "Backup Cloud",
        link: "/backup-cloud",
      },
      {
        id: 39,
        title: "Desenvolvimento Web",
        link: "/desenvolvimento-web",
      },
    ],
  },
  {
    id: 4,
    title: "Projetos Entregues",
    link: "/projects",
  },
  {
    id: 5,
    title: "Contato",
    link: "/contact",
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <ul className="xb-menu-primary clearfix">
        {menus.map((item, mn) => {
          return (
            <ListItem className={item.id === openId ? "active" : null} key={mn}>
              {item.submenu ? (
                <Fragment>
                  <p
                    onClick={() => setOpenId(item.id === openId ? 0 : item.id)}
                  >
                    {item.title}
                    <i
                      className={
                        item.id === openId
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                    ></i>
                  </p>
                  <Collapse
                    in={item.id === openId}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List className="menu-item menu-item-has-children active">
                      <Fragment>
                        {item.submenu.map((submenu, i) => {
                          return (
                            <ListItem key={i}>
                              <Link
                                onClick={ClickHandler}
                                className="active"
                                to={submenu.link}
                              >
                                {submenu.title}
                              </Link>
                            </ListItem>
                          );
                        })}
                      </Fragment>
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <Link className="active" to={item.link}>
                  {item.title}
                </Link>
              )}
            </ListItem>
          );
        })}
      </ul>

      {/* CTA Button */}
      <div
        className="mobile-menu-cta"
        style={{
          padding: "20px 15px",
          borderTop: "1px solid #eee",
          marginTop: "20px",
        }}
      >
        <Link
          onClick={ClickHandler}
          to="/contact"
          className="thm-btn thm-btn--aso thm-btn--header-blue w-100 text-center"
          style={{
            display: "block",
            padding: "12px 20px",
            backgroundColor: "#007bff",
            color: "white",
            textDecoration: "none",
            borderRadius: "5px",
            fontWeight: "600",
          }}
        >
          Marque uma conversa
        </Link>
      </div>
    </div>
  );
};

export default MobileMenu;
